<div style="position:relative;">
  <div class="row-no-margin section-header-container">
    <div class="col-md-12 clear-padding">
      <span class="section-header">Orders</span>
      <div class="row-no-margin">
        <div class="col-md-3 clear-padding">
          <mat-form-field appearance="fill">
            <mat-label>Sort by:</mat-label>
            <mat-select id="orderSort" (selectionChange)="OrderSort_Change($event)" [(value)]="OrderSortValue">
              <mat-option value="orderdate">
                Most Recent
              </mat-option>
              <mat-option value="statusopen">
                Open Orders
              </mat-option>
              <mat-option value="followed">
                Followed Orders
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-6 clear-padding">
          <mat-form-field *ngIf="CurUser.IsTolomaticUser" appearance="fill">
            <mat-label>Distributor:</mat-label>
            <mat-select id="orderDistributor" (selectionChange)="Dist_Change($event)" [value]="CurrentDist">
              <mat-option *ngFor="let dist of DistList" [value]="dist.CompanyId">
                {{dist.Company}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <!--
          <div class="col-md-3">
            <button [matMenuTriggerFor]="FilterMenu" class="blue">FILTERS</button>
            <mat-menu (click)="$event.stopPropagation()" #FilterMenu="matMenu">
              <div (click)="$event.stopPropagation()">
                <div class="row-no-margin">
                  <mat-form-field appearance="fill" style="width:100%;">
                    <mat-label>Order Number</mat-label>
                    <input matInput (click)="$event.stopPropagation()" [(ngModel)]="OrderNumber_Filter.Value" />
                  </mat-form-field>
                </div>

            <div class="row-no-margin">
              <mat-form-field appearance="fill" style="width:100%;">
                <mat-label>Created Date Range</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                  <input matStartDate (click)="$event.stopPropagation()" (dateChange)="SetStartDateFilterValue($event)" [(value)]="OrderDateMin_Filter.Value" />
                  <input matEndDate (click)="$event.stopPropagation()" (dateChange)="SetEndDateFilterValue($event)" [max]="Max_EndDate" [(value)]="OrderDateMax_Filter.Value" />
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
            </div>

            <div class="row-no-margin">
              <mat-form-field appearance="fill" style="width:100%;">
                <mat-label>PO Number</mat-label>
                <input matInput (click)="$event.stopPropagation()" [(ngModel)]="PONumber_Filter.Value" />
              </mat-form-field>
            </div>
            <div class="row-no-margin">

              <mat-form-field appearance="fill" style="width:100%;">
                <mat-label>Ship To</mat-label>
                <input matInput (click)="$event.stopPropagation()" [(ngModel)]="ShipTo_Filter.Value" />
              </mat-form-field>
            </div>
            <div style="position:relative;padding-bottom:30px;">
              <button id="resetSearchFilters" class="blue" style="left:10px;position:absolute;" (click)="ResetFilters()">Reset</button>
              <button id="submitSearch" class="blue" style="right:10px;position:absolute;" (click)="SubmitFilters()">Done</button>
            </div>
          </div>
          </mat-menu>
        </div>
        -->
      </div>
      <div class="row-no-margin">
        <div class="col-md-2 clear-padding">
          <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
            <mat-label>Search by:</mat-label>
            <input matInput class="mat-focused" placeholder="Order Number" [(ngModel)]="OrderNumber_Filter.Value" />
          </mat-form-field>
        </div>
        <div class="col-md-2 lr-p-15">
          <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
            <mat-label>Search by:</mat-label>
            <input matInput class="mat-focused" placeholder="Job Number" [(ngModel)]="JobNumber_Filter.Value" />
          </mat-form-field>
        </div>
        <div class="col-md-2 clear-padding">
          <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
            <mat-label>Search by:</mat-label>
            <input matInput class="mat-focused" placeholder="Serial Number" [(ngModel)]="SerialNumber_Filter.Value" />
          </mat-form-field>
        </div>
        <div class="col-md-2 lr-p-15">
          <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
            <mat-label>Search by:</mat-label>
            <input matInput class="mat-focused" placeholder="Part Number" [(ngModel)]="PartNumber_Filter.Value" />
          </mat-form-field>
        </div>
      </div>
      <div class="row-no-margin">
        <div class="col-md-3 clear-padding">
          <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
            <mat-label>Created Date Range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate (click)="$event.stopPropagation()" placeholder="MM/DD/YYYY" (dateChange)="SetStartDateFilterValue($event)" [(value)]="OrderDateMin_Filter.Value" />
              <input matEndDate (click)="$event.stopPropagation()" placeholder="MM/DD/YYYY" (dateChange)="SetEndDateFilterValue($event)" [max]="Max_EndDate" [(value)]="OrderDateMax_Filter.Value" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="col-md-2 lr-p-15">
          <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
            <mat-label>Search by:</mat-label>
            <input matInput (click)="$event.stopPropagation()" placeholder="PO Number" [(ngModel)]="PONumber_Filter.Value" />
          </mat-form-field>
        </div>
        <div class="col-md-2 clear-padding">
          <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
            <mat-label>Search by:</mat-label>
            <input matInput (click)="$event.stopPropagation()" placeholder="Ship To" [(ngModel)]="ShipTo_Filter.Value" />
          </mat-form-field>
        </div>
        <div class="col-md-3 lr-p-15">
          <button id="submitSearch" class="blue" style="margin-top:10px;" (click)="SubmitFilters()">Search</button>
          <button id="resetSearchFilters" class="blue" style="margin-top:10px;margin-left:10px;" (click)="ResetFilters()">Reset</button>
        </div>
      </div>
    </div>
    <!--<div class="col-md-2 clear-padding" style="text-align:right;">
      <a [routerLink]="['/orderstatus']">View all status</a>
    </div>-->

  </div>
  <div>
    <table style="width:100%;">
      <tr>
        <th></th>
        <th>Order Number</th>
        <th style="text-align:center;">Order Date</th>
        <th style="text-align:center;">Status</th>
        <th style="text-align:center;">PO Number</th>
        <ng-container *ngIf="CurrentDist == '00000000-0000-0000-0000-000000000000'">
          <th style="text-align:center;">Distributor</th>
        </ng-container>
        <th style="text-align:center;">Ship to name</th>

      </tr>
      <ng-container *ngFor="let order of OrderList">
        <tr>
          <td>
            <button mat-icon-button aria-label="expand row" (click)="(order.Expanded = !order.Expanded); LoadDetails(order); $event.stopPropagation()">
              <mat-icon *ngIf="!order.Expanded" class="blue-color">keyboard_arrow_down</mat-icon>
              <mat-icon *ngIf="order.Expanded" class="blue-color">keyboard_arrow_up</mat-icon>
            </button>
          </td>
          <td>
            {{order.OrderNumber}}
          </td>
          <td style="text-align:center;">{{order.OrderDate | date:'M/d/y'}}</td>
          <td style="text-align:center;">{{order.Status}}</td>
          <td style="text-align:center;">{{order.PONumber}}</td>
          <ng-container  *ngIf="CurrentDist == '00000000-0000-0000-0000-000000000000'">
            <td>{{order.DistributorName}}</td>
          </ng-container>
          <td>
            <span [matTooltip]="order.ShipToName">
              {{order.ShortShipTo}}
              </span>
            </td>
        </tr>
        <ng-container *ngIf="order.Expanded">
          <tr>
            <td colspan="7">
              <table class="sub-table" style="width:100%;">
                <tr>
                  <th style="text-align:center;">Line</th>
                  <th>Item</th>
                  <th>Description</th>
                  <th style="text-align:center;">QTY</th>
                  <th style="text-align:center;">List Price</th>
                  <th style="text-align:center;">Unit Price</th>
                  <th style="text-align:center;">Ext Price</th>
                  <th style="text-align:center;">Status</th>
                  <th style="text-align:center;">Due Date</th>
                  <th style="text-align:center;">(Est) Ship Date</th>
                  <th style="text-align:center;">Tracking</th>
                  <th style="text-align:center;">Follow</th>
                </tr>
                <ng-container *ngFor="let detail of order.OrderLines | sort: 'OrderLine'">
                  <tr>
                    <td style="text-align:center;">
                      {{detail.OrderLine}}
                    </td>
                    <td>
                      {{detail.Item}}
                    </td>
                    <td>
                      <span [matTooltip]="detail.Description">
                        {{detail.ShortDesc}}
                      </span>
                    </td>
                    <td style="text-align:center;">
                      {{detail.QtyOrdered}}
                    </td>
                    <td style="text-align:center;">
                      {{detail.ListPrice | currency:'USD':'symbol-narrow':'1.2-2'}}
                    </td>
                    <td style="text-align:center;">
                      {{detail.Price | currency:'USD':'symbol-narrow':'1.2-2'}}
                    </td>
                    <td style="text-align:center;">
                      {{detail.ExtPrice | currency:'USD':'symbol-narrow':'1.2-2'}}
                    </td>
                    <td style="text-align:center;">
                      <ng-container *ngIf="detail.SourceType == 'I'">
                        <span class="clickable blue-color" (click)="ViewDetails(order,detail)">Inventory Item</span>
                      </ng-container>
                      <ng-container *ngIf="detail.SourceType != 'I'">
                        <span class="clickable blue-color" (click)="ViewDetails(order,detail)">{{detail.PortalStatus}}</span>
                      </ng-container>
                    </td>
                    <td style="text-align:center;">
                      {{detail.DueDate  | date:'M/d/y'}}
                    </td>
                    <td style="text-align:center;">
                      <ng-container *ngIf="detail.ShipDate == null && detail.EstShipDate != null && detail.EstShipDate.length > 0">
                        ({{detail.EstShipDate  | date:'M/d/y'}})
                      </ng-container>
                      <ng-container *ngIf="detail.ShipDate != null && (detail.EstShipDate == detail.ShipDate || detail.EstShipDate == null || detail.EstShipDate.length == 0)">
                        {{detail.ShipDate  | date:'M/d/y'}}
                      </ng-container>
                    </td>
                    <td style="text-align:center;">
                      <span [innerHtml]="detail.TrackingNumber"></span>

                    </td>
                    <td style="text-align:center;"><app-toggle [initial]="detail.Followed" [idForControl]="detail.OrderDetailRowPointer" [trueText]="" [falseText]="" (changed)="FollowOrder($event,detail.OrderDetailRowPointer)"></app-toggle></td>
                  </tr>
                </ng-container>
              </table>
            </td>
          </tr>
        </ng-container>
      </ng-container>

    </table>
    <mat-paginator [length]="ItemCount" [pageSize]="PageSize" [pageSizeOptions]="PageSizeOptions" (page)="PageEvent($event)">
    </mat-paginator>
  </div>
  <div #spinnerModal id="spinnerModal" [hidden]="hideLoadingModal" style="width:100%;height:inherit;float:left;position:absolute;z-index:10000;display:block;left:0;top:0px;bottom:0px; background-color:#AAAAAA;opacity:0.4;">
    <div style="position: absolute; top: 45%; left: 45%;">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  </div>
</div>
